import { useNavigate, useParams } from "react-router-dom";
import { ORGANIZATION_SETTIGS_BY_ALIAS } from "../constant";

export const useOrganizationDetails = () => {
  const navigate = useNavigate();
  const { organizationAlias } = useParams<{
    organizationAlias?: string;
  }>();

  const alias = organizationAlias?.toLocaleLowerCase();

  if (!alias) {
    navigate("/");
    return undefined;
  }

  const organizationDetails = ORGANIZATION_SETTIGS_BY_ALIAS[alias]
    ? {
        alias,
        ...ORGANIZATION_SETTIGS_BY_ALIAS[alias],
      }
    : undefined;

  if (!organizationDetails) {
    navigate("/");
    return undefined;
  }

  return organizationDetails;
};
